import React, { useState } from 'react';
import { Button, Drawer } from 'antd';
import MemberSelector from '../components/MemberSelector';
import StudentArchive from '../components/StudentArchive';

// 配置常量已移至StudentArchive组件中定义

const StudentProfile = ({ user }) => {
  const [selectedMember, setSelectedMember] = useState(null);
  const [isMemberDrawerVisible, setIsMemberDrawerVisible] = useState(false);





  const handleSaveSuccess = () => {
    // 保存成功后的回调处理
    console.log('档案保存成功');
  };

  // 删除遗留的未使用配置常量
  // 这些配置已经在StudentArchive组件中定义

  return (
    <div style={{ padding: '16px', overflow: 'auto' }}>
      <div style={{ marginBottom: 16, textAlign: 'right' }}>
        <Button onClick={() => setIsMemberDrawerVisible(true)}>选择学员</Button>
      </div>
      
      {selectedMember ? (
        <StudentArchive 
          memberId={selectedMember.id}
          memberInfo={selectedMember}
          onSaveSuccess={handleSaveSuccess}
        />
      ) : (
        <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
          <h3>请选择学员查看档案信息</h3>
        </div>
      )}
      
      <Drawer
        title="选择学员"
        placement="right"
        width={480}
        onClose={() => setIsMemberDrawerVisible(false)}
        open={isMemberDrawerVisible}
      >
        <MemberSelector onSelect={(member) => { setSelectedMember(member); setIsMemberDrawerVisible(false); }} />
      </Drawer>
    </div>
  );
};
export default StudentProfile;
